(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["gulabo-product-tabs"] && !Shopify.designMode) return;
  try {
    
  class GulaboProductTabs extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready === 'true') return;
      this.dataset.ready = 'true';
      this.buttons = Array.from(this.querySelectorAll('[data-tab-button]'));
      this.panels = Array.from(this.querySelectorAll('[data-tab-panel]'));

      if (this.buttons.length === 0) return;

      this.buttons.forEach((button, index) => {
        button.addEventListener('click', () => this.selectTab(index));
        button.addEventListener('keydown', (event) => this.handleKeydown(event, index));
      });
    }

    selectTab(index) {
      this.buttons.forEach((button, buttonIndex) => {
        const selected = buttonIndex === index;
        button.setAttribute('aria-selected', selected ? 'true' : 'false');
        button.tabIndex = selected ? 0 : -1;
      });

      this.panels.forEach((panel, panelIndex) => {
        panel.hidden = panelIndex !== index;
      });
    }

    handleKeydown(event, index) {
      let nextIndex = index;

      if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.buttons.length;
      if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.buttons.length) % this.buttons.length;
      if (event.key === 'Home') nextIndex = 0;
      if (event.key === 'End') nextIndex = this.buttons.length - 1;
      if (nextIndex === index) return;

      event.preventDefault();
      this.selectTab(nextIndex);
      this.buttons[nextIndex].focus();
    }
  }

  if (!customElements.get('gulabo-product-tabs')) {
    customElements.define('gulabo-product-tabs', GulaboProductTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
